export default __webpack_public_path__ + "static/media/selected_resumes.ba30b41d.svg";